export type MatchupOutlookState =
  | "clearAdvantage"
  | "even"
  | "slightAdvantage"
  | "slightDisadvantage"
  | "tough";

export type MatchupOutlook = {
  score: number;
  state: MatchupOutlookState;
};

export const getMatchupOutlook = ({
  projectedMarginForTeamZero,
  userTeamIndex,
}: {
  projectedMarginForTeamZero: number;
  userTeamIndex: 0 | 1;
}): MatchupOutlook => {
  const userEdge = userTeamIndex === 0 ? projectedMarginForTeamZero : -projectedMarginForTeamZero;

  if (userEdge <= -7) {
    return { score: 12, state: "tough" };
  }
  if (userEdge <= -2) {
    return { score: 34, state: "slightDisadvantage" };
  }
  if (userEdge < 2) {
    return { score: 52, state: "even" };
  }
  if (userEdge < 7) {
    return { score: 72, state: "slightAdvantage" };
  }

  return { score: 92, state: "clearAdvantage" };
};
